import React from "react";
import CustomInput from "../../../components/CustomForm/CustomInput";
import CustomButton from "../../../components/CustomButton/CustomButton";
import {
  FormWrapper,
  Form,
  FormGroup,
} from "../../../components/CustomForm/FormStyles";
import useEmpresa from "../../../hooks/useEmpresa";
import Colors from "../../../themes/Colors";

const BusquedaAutorizacionForm = ({
  numeroBusqueda,
  fechaInicio,
  fechaFin,
  onStateChange,
  onSearch,
  isLoading,
}) => {
  const empresa = useEmpresa();

  return (
    <FormWrapper borderColor={Colors.transparent}>
      <Form justifyContent={"space-between"}>
        <FormGroup>
          <CustomInput
            type={"text"}
            placeholder={`No. Autorización o ${empresa?.TIPO_CLIENTE}`}
            label={"No. Autorización o " + empresa?.TIPO_CLIENTE}
            isLabelWithContainer={true}
            labelWidth={"270px"}
            width={"250px"}
            value={numeroBusqueda}
            onChange={onStateChange("numeroBusqueda")}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"date"}
            maxDate={fechaFin}
            required={true}
            placeholder={"Fecha Desde"}
            label={"Desde"}
            isLabelWithContainer={true}
            labelWidth={"270px"}
            width={"250px"}
            value={fechaInicio}
            onChange={onStateChange("fechaInicio")}
          />
        </FormGroup>
        <FormGroup>
          <CustomInput
            type={"date"}
            minDate={fechaInicio}
            required={true}
            placeholder={"Fecha Hasta"}
            label={"Hasta"}
            isLabelWithContainer={true}
            labelWidth={"270px"}
            width={"250px"}
            value={fechaFin}
            onChange={onStateChange("fechaFin")}
          />
        </FormGroup>
        <FormGroup>
          <CustomButton
            label={"Buscar"}
            onClick={onSearch}
            isLoading={isLoading}
            height={"46px"}
            width={"100px"}
          />
        </FormGroup>
      </Form>
    </FormWrapper>
  );
};

export default BusquedaAutorizacionForm;